import { render, staticRenderFns } from "./groupnotice.vue?vue&type=template&id=c0f4c4ec&"
import script from "./groupnotice.js?vue&type=script&lang=js&"
export * from "./groupnotice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports